(function () {
  const SPLIT_SELECTOR = '[data-split-line]:not([data-split-line-ready])';
  const BUTTON_SELECTOR = '[data-animate]:not([data-animate-ready])';

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function waitForGsap() {
    return new Promise((resolve) => {
      const ready = () => window.gsap && window.ScrollTrigger && window.SplitText;

      if (ready()) {
        resolve();
        return;
      }

      const check = () => {
        if (ready()) {
          resolve();
        } else {
          requestAnimationFrame(check);
        }
      };

      check();
    });
  }

  function getRoot(scope) {
    if (!scope || scope === document) {
      return document;
    }

    return scope.querySelector?.('return-cta, app-cta, [id^="ReturnCta-"], [id^="AppCta-"]') || scope;
  }

  function initSplitLines(root) {
    if (prefersReducedMotion()) {
      return;
    }

    const blocks = root.querySelectorAll(SPLIT_SELECTOR);
    if (!blocks.length) {
      return;
    }

    blocks.forEach((block) => {
      block.setAttribute('data-split-line-ready', '');

      const split = SplitText.create(block, {
        type: 'lines',
        mask: 'lines',
        linesClass: 'cta-reveal-line++',
      });

      const lines = split.lines;
      if (!lines || !lines.length) {
        return;
      }

      gsap.timeline({
        scrollTrigger: {
          trigger: block,
          start: 'top 92%',
          once: true,
          toggleActions: 'play none none none',
        },
      }).fromTo(
        lines,
        { yPercent: 140 },
        {
          delay: 0.2,
          yPercent: 0,
          duration: 1.5,
          ease: 'power4.out',
          stagger: { each: 0.2 },
        }
      );
    });
  }

  function initButtons(root) {
    const buttons = root.querySelectorAll(BUTTON_SELECTOR);
    if (!buttons.length) {
      return;
    }

    if (prefersReducedMotion()) {
      buttons.forEach((button) => {
        button.setAttribute('data-animate-ready', '');
        button.classList.add('is-cta-animated');
      });
      return;
    }

    buttons.forEach((button, index) => {
      button.setAttribute('data-animate-ready', '');

      gsap.set(button, { opacity: 0, y: 24, scale: 0.96 });

      gsap.to(button, {
        opacity: 1,
        y: 0,
        scale: 1,
        duration: 0.75,
        delay: index * 0.08,
        ease: 'power3.out',
        onComplete: () => {
          button.classList.add('is-cta-animated');
        },
        scrollTrigger: {
          trigger: button,
          start: 'top 92%',
          once: true,
        },
      });
    });
  }

  async function initCtaAnimations(scope) {
    await waitForGsap();

    window.gsap.registerPlugin(window.ScrollTrigger, window.SplitText);

    const root = getRoot(scope);
    await document.fonts.ready;

    initSplitLines(root);
    initButtons(root);
    window.ScrollTrigger.refresh();
  }

  function onReady() {
    initCtaAnimations(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initCtaAnimations(event.target);
  });
})();
